import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';
import { ProformaFront } from '../../../models/api.models';

@Component({
  selector: 'app-proforma',
  templateUrl: './proforma.component.html',
  styleUrls: ['./proforma.component.scss'],
})
export class ProformaComponent implements OnInit {

  @Input() proforma: ProformaFront;

  constructor(private router: Router) { }

  ngOnInit() {}

  ver(proforma: ProformaFront) {
    this.router.navigate(['main', 'lineas-proforma', proforma.id]);
  }

}
